import { render, staticRenderFns } from "./SupplierForm.vue?vue&type=template&id=808b3216&"
import script from "./SupplierForm.vue?vue&type=script&lang=js&"
export * from "./SupplierForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('808b3216')) {
      api.createRecord('808b3216', component.options)
    } else {
      api.reload('808b3216', component.options)
    }
    module.hot.accept("./SupplierForm.vue?vue&type=template&id=808b3216&", function () {
      api.rerender('808b3216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/purchase/purchase-order/components/SupplierForm.vue"
export default component.exports